__turbopack_context__.v({
  "emptyTableDisplay": "AppDetailsEmpty-module__fDlFAW__emptyTableDisplay",
});
